import { ReactNode } from '@tanstack/react-router'

export interface WidgetLabelProps {
	children: ReactNode
	label: ReactNode
	labelId?: string
	htmlFor?: string
	position?: 'above' | 'below'
	trailing?: ReactNode
}

export function WidgetLabel({ children, label, labelId, htmlFor, position = 'above', trailing }: WidgetLabelProps) {
	const labelContent = (
		<div className="flex items-center gap-1">
			<label id={labelId} htmlFor={htmlFor} className="grid text-[11px] text-grey-400">{label}</label>
			<div className="flex-1" />
			{trailing && <span className="shrink-0">{trailing}</span>}
		</div>
	)

	return (
		<div className="relative grid gap-0.5">
			{position === 'above' && labelContent}
			<div className="grid relative">{children}</div>
			{position === 'below' && labelContent}
		</div>
	)
}
